import React, { useState, useEffect } from "react";
import { MissionSubCard, MissionSubCardHorizontalDivider } from "./MissionLayoutComponents";
import { useAlert } from 'react-alert';
import { useNavigate } from "react-router-dom";

import Button from "../../common_components/Button";
import Timeline from "./Timeline";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
// API Calls
import MissionUserListAPI from "../../../api/api_calls/MissionUserListAPI";
import MissionUserApprovalAPI from "../../../api/api_calls/MissionUserApprovalAPI";

function MissionNotApplied({ mission, userMissionState, refreshMissionStatus }) {
    const alert = useAlert();
    // Set button to full width if the screen is < 840px
    const fullWidthButton = window.innerWidth < 840;

    const [userApprovalStatus, setUserApprovalStatus] = useState(null);
    const [unmetRequirements, setUnmetRequirements] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleApply = async () => {
        const response = await MissionUserListAPI.create(mission.id);
        if (response.success) {
            refreshMissionStatus();
        } else {
            console.error("Error applying to mission", response);
            alert.error("Error applying to mission");

        }
    }

    //Load the user's approval status
    useEffect(() => {
        const loadUserApprovalStatus = async () => {
            const response = await MissionUserApprovalAPI.show(mission.id);
            if (response.success) {
                setUserApprovalStatus(response.status);
                // Rejection_Reason_json is either {} or {unmet_requirements: [...]}
                // If it's {}. then return an empty array
                const rejectionReasonJson = response.rejection_reason_json.unmet_requirements || [];
                setUnmetRequirements(rejectionReasonJson);
                setIsLoading(false);
            } else {
                alert.error("Error loading mission approval.");
            }
        }
        loadUserApprovalStatus();
    }, []);

    return (
        <>
            <UnmetRequirementHighlights unmetRequirements={unmetRequirements} />
            <MissionSubCard>
                <Timeline mission={mission} userMissionState={userMissionState} />
                <MissionSubCardHorizontalDivider />
                {isLoading ? <CenteredLoadingIcon /> :

                    <Button size="medium" color="primary" fullWidth={fullWidthButton} disabled={userApprovalStatus != "approved"} onClick={handleApply}>Apply & Earn {mission.reward}</Button>
                }
            </MissionSubCard>
        </>
    )
}

function UnmetRequirementHighlights({ unmetRequirements }) {
    const navigate = useNavigate();
    if (unmetRequirements.length == 0) {
        return null;
    } else {
        // First, we group by the "type" of unmet requirement
        const groupedUnmetRequirements = unmetRequirements.reduce((acc, requirement) => {
            const type = requirement.type;
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(requirement);
            return acc;
        }, {});

        // Then, we render the grouped unmet requirements
        return (
            <>
                {groupedUnmetRequirements["MissionRequirement"] &&
                    <div className="unmet-requirement-highlight">
                        <div className="unmet-requirement-text body-small">Provide additional profile details to qualify</div>
                        <Button size="small" color="primary" onClick={() => navigate("/boosters/extended-profile")}>Visit profile</Button>
                    </div>
                }
                {groupedUnmetRequirements["WalletRequirement"] &&
                    <div className="unmet-requirement-highlight">
                        <div className="unmet-requirement-container">
                            <div className="unmet-requirement-text body-small">Verify wallets that meet the following requirements to qualify:</div>
                            <ul className="unmet-requirement-list">
                                {groupedUnmetRequirements["WalletRequirement"].map((requirement) => (
                                    <li key={requirement.id} className="unmet-requirement-list-item unmet-requirement-text body-small">{requirement.reason_details}</li>
                                ))}
                            </ul>
                        </div>
                        <Button size="small" color="primary" onClick={() => navigate("/wallets")}>Connect wallet</Button>
                    </div>
                }
            </>
        )
    }
}

export default MissionNotApplied;